import { useMemo } from 'react';
import { View } from 'foundations-components/components/View';
import useCrmObjectTypeListingFilters from 'framework-listing-lib/hooks/useCrmObjectTypeListingFilters';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const SPECIAL_CHARACTERS_REGEXP = /[.*+\-?^${}()|[\]\\]/g;
function SpanForPart({
  part,
  highlight
}) {
  if (highlight && part.toLowerCase() === highlight.toLowerCase()) {
    return /*#__PURE__*/_jsx(View, {
      as: "span",
      backgroundColor: "fill-accent-yellow-default",
      "data-test-id": "highlighted-string",
      children: part
    });
  } else {
    return /*#__PURE__*/_jsx("span", {
      "data-test-id": "non-highlighted-string",
      children: part
    });
  }
}

/**
 * Backslash escape the following special characters:
 *   . * + - ? ^ $ { } ( ) | [ ] \
 */
export function escapeSpecialCharacters(value) {
  return value.replace(SPECIAL_CHARACTERS_REGEXP, '\\$&');
}
function getParts(value, highlight) {
  if (highlight) {
    // Backslash escape any characters that have special meaning in a Regexp,
    // to ensure the split works correctly.
    //
    // Incorrect:
    //   'A B+C D'.split(new RegExp(`(B+C)`, 'gi')) -> ['A B+C D']
    //
    // Correct:
    //   'A B+C D'.split(new RegExp(`(B\\+C)`, 'gi')) -> ['A ', 'B+C', ' D']
    return value.split(new RegExp(`(${escapeSpecialCharacters(highlight)})`, 'gi'));
  } else {
    return [value];
  }
}
export default function ListingLibHighlightString({
  value
}) {
  const {
    filters
  } = useCrmObjectTypeListingFilters();
  const spans = useMemo(() => getParts(value, filters.query).map((part, index) => /*#__PURE__*/_jsx(SpanForPart, {
    part: part,
    highlight: filters.query
  }, index)), [value, filters.query]);
  return /*#__PURE__*/_jsx(_Fragment, {
    children: spans
  });
}